//#region redux
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { invoiceAssignedNewOwnerMyself, invoiceAssignedNewOwnerOthers } from "store/actions/invoiceActions";
//#endregion
//#region types
import { StyleEnums, DialogEnums } from "models/enums";
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { useInvoiceService } from "serviceHooks";
import useInvoicePermissions from "../useInvoicePemissions";
//#endregion
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";

function useAssignOwner(id?: number, invoiceOwnerId?: number, reloadHandler?: () => void) {
  const invoiceService = useInvoiceService();
  const dispatch = useDispatch();

  const loggedInUserId = useSelector((state: AppState) => state.auth.loggedInUser.personId);

  const { getIsInvoiceAdmin } = useInvoicePermissions();

  const getAssignNewOwnerSuggestions = () => {
    return UtilsHelper.convertToResultItem(
      invoiceService.getSuggestedInvoicePersons(true, invoiceOwnerId ? [invoiceOwnerId] : [])
    );
  };

  const searchAssignNewOwner = (searchText: string) => {
    return UtilsHelper.convertToResultItem(
      invoiceService.getInvoicePersons(searchText, true, invoiceOwnerId ? [invoiceOwnerId] : [])
    );
  };

  const onNewOwnerSelect = (item: SelectionItem | SelectionItem[]) => {
    const selectedItem = item as SelectionItem;
    return invoiceService.assignNewOwner(id!, {
      newOwnerId: selectedItem.id as number,
    });
  };

  const onAssignOwnerSuccess = () => {
    reloadHandler && reloadHandler();
    invoiceService.get(id!).then((result) => {
      if (
        loggedInUserId === result.ownerId &&
        (result.status === WintSuperkollAPIModel.InvoiceStatus.NotSent ||
          result.status === WintSuperkollAPIModel.InvoiceStatus.OverdueReminderNotSent)
      ) {
        dispatch(invoiceAssignedNewOwnerMyself(result));
      } else {
        id && dispatch(invoiceAssignedNewOwnerOthers(id));
      }
    });
  };

  const getAssignOwnerAction = () => {
    if (id === undefined || !getIsInvoiceAdmin()) return;

    const assignOwnerAction: MoreActionMenuItemType = {
      description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.AssignOwner),
      icon: IconDefinitionConstants.WUser,
      actionDialog: {
        isOpen: false,
        title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.AssignOwner),
        subTitle: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ReAssignResponsibility),
        titleIcon: IconDefinitionConstants.WUser,
        dialogType: DialogEnums.DialogType.Selection,
        children: {
          getSuggestions: getAssignNewOwnerSuggestions,
          search: searchAssignNewOwner,
          handleSubmit: onNewOwnerSelect,
          submitSuccessMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Invoice.AssignNewOwnerSuccessMessage
          ),
        },
        maxWidth: "sm",
        type: StyleEnums.DisplayType.Info,
      },
      highlightType: StyleEnums.DisplayType.Info,
      onActionSuccess: onAssignOwnerSuccess,
    };
    return assignOwnerAction;
  };

  return { getAssignOwnerAction };
}
export default useAssignOwner;
